import { Service } from '@angular/core';
import { PageState, PageStateBase, PageStateService, PageDataServiceBase } from '@portal-core/data/page/services/page.state';
import { ProjectReportStatistics } from '@portal-core/reports/models/project-report-statistics.model';
import { ProjectReportStatisticsState } from '@portal-core/reports/services/project-report-statistics-data.service';

@PageState({
  name: 'projectReportsPageState',
  actionName: 'ProjectReportsPage',
  defaults: {
    filters: {
      chartSize: 10
    }
  }
})
export class ProjectReportsPageState extends PageStateBase {}

@Service()
@PageStateService<ProjectReportStatistics>({
  pageState: ProjectReportsPageState,
  itemCollectionState: ProjectReportStatisticsState
})
export class ProjectReportsPageDataService extends PageDataServiceBase<ProjectReportStatistics> {
  override state = ProjectReportsPageState;
}
